module.exports = __webpack_public_path__ + "assets/img/station.04e449e0.png";